export const PROVIDER_ESCAPIO = "ESCAPIO";
